// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activeLicense__de2 {
  color: var(--ring-success-color);
}
`, "",{"version":3,"sources":["webpack://./src/modules/license-vault/licences-table/licenses-table.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC","sourcesContent":[".activeLicense {\n  color: var(--ring-success-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeLicense": `activeLicense__de2`
};
export default ___CSS_LOADER_EXPORT___;
